import React, { useEffect, useState, useCallback } from "react";
import "./App.css";

function App() {
  const [students, setStudents] = useState([]);
  const [name, setName] = useState("");
  const [roll, setRoll] = useState("");
  const [branch, setBranch] = useState("");
  const [group, setGroup] = useState(""); // ✅ New state for Group
  const [branches, setBranches] = useState([]);
  const [groups, setGroups] = useState([]); // ✅ List of groups
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [lastUpdated, setLastUpdated] = useState(null);

  // Fetch students with filters
  const fetchStudents = useCallback(async () => {
    try {
      const params = new URLSearchParams({
        name,
        roll,
        branch,
        group, // ✅ Include group in query
        page,
        pageSize,
      });
      const res = await fetch(`/api/students?${params.toString()}`);
      const data = await res.json();
      setStudents(data.students || []);
      setTotalPages(data.totalPages || 1);
      setLastUpdated(data.lastUpdated || null);
    } catch (err) {
      console.error("Error fetching students:", err);
    }
  }, [name, roll, branch, group, page, pageSize]);

  // Fetch unique branches
  const fetchBranches = useCallback(async () => {
    try {
      const res = await fetch("/api/branches");
      const data = await res.json();
      setBranches(data.branches || []);
    } catch (err) {
      console.error("Error fetching branches:", err);
    }
  }, []);

  // Fetch unique groups
  const fetchGroups = useCallback(async () => {
    try {
      const res = await fetch("/api/groups");
      const data = await res.json();
      setGroups(data.groups || []);
    } catch (err) {
      console.error("Error fetching groups:", err);
    }
  }, []);

  // Initial load
  useEffect(() => {
    fetchBranches();
    fetchGroups();
    fetchStudents();
  }, [fetchBranches, fetchGroups, fetchStudents]);

  // Auto-refresh every 30 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      fetchStudents();
    }, 30000);
    return () => clearInterval(interval);
  }, [fetchStudents]);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    fetchStudents();
  };

  const handleResetFilters = () => {
    setName("");
    setRoll("");
    setBranch("");
    setGroup(""); // ✅ Reset group
    setPage(1);
    fetchStudents();
  };

  return (
    <div className="container">
      <h2>🔍 U2U Student Intern Information Portal</h2>
       <h3> This portal is for all students doing internships through U2USystems </h3>
      {lastUpdated && (
        <p className="last-updated">
          Last updated: {new Date(lastUpdated).toLocaleString()}
        </p>
      )}

      {/* SEARCH FORM */}
      <form
        onSubmit={handleSearch}
        className="search-form"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{ flex: "1 1 150px", padding: "5px" }}
        />
        <input
          type="text"
          placeholder="Roll"
          value={roll}
          onChange={(e) => setRoll(e.target.value)}
          style={{ flex: "1 1 100px", padding: "5px" }}
        />
        <select
          value={branch}
          onChange={(e) => setBranch(e.target.value)}
          style={{ flex: "1 1 150px", padding: "5px" }}
        >
          <option value="">All Branches</option>
          {branches.map((b, idx) => (
            <option key={idx} value={b}>
              {b}
            </option>
          ))}
        </select>
       
<select
          value={group}
          onChange={(e) => setGroup(e.target.value)}
          style={{ flex: "1 1 150px", padding: "5px" }}
        >
          <option value="">All Groups</option>
          {groups.map((g, idx) => (
            <option key={idx} value={g}>
              {g}
            </option>
          ))}
        </select>

        


        <button type="submit" style={{ padding: "5px 10px" }}>
          Search
        </button>
        <button
          type="button"
          onClick={handleResetFilters}
          style={{ padding: "5px 10px" }}
        >
          Reset Filters
        </button>
      </form>

      {/* STUDENT LIST */}
      <div className="student-list">
        {students.length === 0 ? (
          <p>No students found.</p>
        ) : (
          students.map((student, idx) => (
            <div
              key={idx}
              className="student-card"
              style={{ marginBottom: "15px" }}
            >
              {Object.keys(student)
                .filter((key) => key.toLowerCase() !== "scrapedat") // hide scrapedat
                .map((key) => (
                  <p key={key}>
                    <strong>
                      {key.charAt(0).toUpperCase() + key.slice(1)}:
                    </strong>{" "}
                    {student[key]}
                  </p>
                ))}
              <hr />
            </div>
          ))
        )}
      </div>

      {/* PAGINATION */}
      {totalPages > 1 && (
        <div className="pagination" style={{ marginTop: "20px" }}>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i}
              onClick={() => setPage(i + 1)}
              className={page === i + 1 ? "active" : ""}
              style={{ margin: "0 3px", padding: "5px 10px" }}
            >
              {i + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default App;